import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=50448ac8"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50448ac8')) {
      api.createRecord('50448ac8', component.options)
    } else {
      api.reload('50448ac8', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=50448ac8", function () {
      api.rerender('50448ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Badge.vue"
export default component.exports